








































































































































































































import Vue from 'vue';

import settingsPannel from '../settings.vue';

import { MDCTextField } from '@material/textfield';
import { MDCRipple } from '@material/ripple';
import { MDCDialog } from '@material/dialog';

import filePreview, { InternalFile } from '../../contentManager/filePreview.vue';
import Axios from 'axios';
import { Interface } from 'readline';

interface Data {
  files: InternalFile[];
  tags?: Tags;
  filters: Filters;
  done: boolean;
  wipDialog: MDCDialog;
}

interface Tags {
  mdcElement: HTMLElement;
  mdc: MDCTextField;
  tags: string[];
}

interface Filters {
  start: number;
  tags: string[];
  tagsHelper: string[];
}

interface Props {
  asSelector: string;
}

export default Vue.extend({
  data(): Data {

    return {
      files: [],
      tags: {} as Tags,
      filters: {
        tagsHelper: [] as string[],
      } as Filters,
      done: true,
      wipDialog: {} as MDCDialog,
    };
  },
  props: [
    'asSelector',
  ],
  mounted() {
    window.onbeforeunload = this.beforeYouLeave;
    this.loadContent(0, false, []);

    const V = this as any;

    V.tags.mdcElement = this.$el.querySelector('#contentFiltersArea .mdc-text-field') as HTMLElement;
    // const tagFilterElem = this.$el.querySelector('#contentFiltersArea .mdc-text-field') as HTMLElement;
    V.tags.mdc = new MDCTextField(V.tags.mdcElement);

    const dialElem = this.$el.querySelector('.mdc-dialog') as HTMLElement;
    V.wipDialog = new MDCDialog(dialElem);
  },
  updated() {
    const el = this.$el.querySelector('#showMoreBut');
    if (el != null) {
      const buttonRipple = new MDCRipple(el);
    }
  },
  destroyed() {
    this.wipDialog.destroy();
  },
  beforeRouteLeave(to, from, next) {
    if (this.isBusy()) {
      this.wipDialog.open();
      return next(false);
    }
    window.onbeforeunload = null;
    return next();
  },
  methods: {
    beforeYouLeave(): string | null {
      if (this.isBusy()) {
        return 'Do you really want to leave our brilliant application?';
      }
      window.onbeforeunload = null;
      return null;
    },
    isBusy(): boolean {
      for (const file of this.files) {
        if (!file.uploaded || file.onUpload) {
          return true;
        }
      }

      return false;
    },
    dropFile(ev: DragEvent) {

      const dropZone = document.getElementById('dropZone');
      if (dropZone != null) {
        dropZone.classList.remove('over');
      }

      // Prevent default behavior (Prevent file from being opened)
      ev.preventDefault();

      if (ev.dataTransfer == null) {
        return;
      }

      if (ev.dataTransfer.items) {
        // Use DataTransferItemList interface to access the file(s)
        for (const item of ev.dataTransfer.items) {
          // If dropped items aren't files, reject them
          if (item.kind === 'file') {
            const file = item.getAsFile();
            if (file != null) {
              this.files.unshift(new InternalFile(file, false));
            }
          }
        }
      } else {
        // Use DataTransfer interface to access the file(s)
        for (const file of ev.dataTransfer.files) {
          if (file != null) {
            this.files.unshift(new InternalFile(file, false));
          }
        }
      }
    },
    dragOver(ev: DragEvent) {
      // Prevent default behavior (Prevent file from being opened)
      ev.preventDefault();
    },
    dragEnter(ev: DragEvent) {
      const dropZone = document.getElementById('dropZone');
      if (dropZone != null) {
        dropZone.classList.add('over');
      }
    },
    dragLeave(ev: DragEvent) {
      const dropZone = document.getElementById('dropZone');
      if (dropZone != null) {
        dropZone.classList.remove('over');
      }
    },
    clickedOnDropZone(ev: MouseEvent) {
      const input: HTMLElement | null = document.querySelector('#dropZone>input');
      if (input != null) {
        input.click();
      }
    },
    fileSeleted(ev: Event) {
      const input: any | null = document.querySelector('#dropZone>input');
      if (input != null) {
        const fileList = input.files as File[];
        for (const file of fileList) {
          this.files.unshift(new InternalFile(file, false));
        }

        // Clean the input to detect next time even if the same file is used
        input.value = '';
      }
    },
    showMore() {
      let nbLoaded = 0;
      for (const file of this.files as InternalFile[]) {
        if (file.uploaded) {
          nbLoaded++;
        }
      }

      this.loadContent(nbLoaded, false, this.filters.tags);
    },
    loadContent(start: number, clean: boolean, tags: string[]) {
      const cleanTags = [] as string[];
      for (const tag of tags) {
        if (tag !== '') {
          cleanTags.push(tag);
        }
      }
      tags = cleanTags;

      const v = this;


      // If no difference from last display no need to reload
      if (
        this.filters.start === start &&
        // This is a trick to check if arrays are equal
        JSON.stringify(tags) === JSON.stringify(this.filters.tags)
      ) {
        return;
      }

      if (clean) {
        // clean element if needed
        const newList = [] as InternalFile[];
        for (const file of v.files as InternalFile[]) {
          if (!file.uploaded) {
            newList.push(file);
          }
        }

        v.files = newList;
      }

      this.filters.start = start;
      this.filters.tags = tags;

      Axios.get('/API/admin/content', {
        headers: { start, tags },
      }).then((resp) => {
        if (resp.status === 204) {
          v.done = true;
          return;
        }

        const data = resp.data.Content as object[];
        v.done = resp.data.Done as boolean;
        if (data) {
          for (const content of data) {
            const newCont = v.convContent(content);
            v.files.push(newCont);
          }
        }
      });
    },
    convContent(givenContent: any): InternalFile {
      const ret = new InternalFile(null, true);
      ret.id = givenContent.ID;
      ret.name = givenContent.Name;
      ret.lastMod = givenContent.LastMod;
      ret.size = givenContent.Size;
      ret.type = givenContent.Type;
      ret.tags = givenContent.Tags;

      if (ret.tags == null) {
        ret.tags = [] as string[];
      }

      return ret;
    },
    rmContent(index: number) {
      // Get the list of files as the right type
      const list = this.files as InternalFile[];
      // Get the start of the list to the index to remove
      const list1 = list.slice(0, index);
      // Get the end of the list from the index plus 1 to the end
      const list2 = list.slice(index + 1);
      // Concatenate the tow arrays
      const newList = list1.concat(list2);
      // set the new list
      this.files = newList;
    },
    updateFilter(ev: KeyboardEvent) {
      if (ev.keyCode === 13 || ev.keyCode === 32) {
        const target = ev.target as HTMLInputElement;
        const tagsAsString = target.value;
        const tagsAsArray = tagsAsString.split(' ');
        this.loadContent(0, true, tagsAsArray);
      }
    },
    updateTagHelpers(ev: Event) {
      const target = ev.target as HTMLInputElement;
      const tagsAsString = target.value;
      const tagsAsArray = tagsAsString.split(' ');

      const lastTag = tagsAsArray.pop() as string;

      this.askForSimilarTags(lastTag);
    },
    askForSimilarTags(tag: string) {
      if (tag === '') {
        this.filters.tagsHelper = [] as string[];
        return;
      }

      const v = this as any;
      Axios.get('/API/admin/content/matchingTags/' + tag).then((resp) => {
        const tags = resp.data;
        if (tags === '') {
          v.filters.tagsHelper = [];
          return;
        }

        v.filters.tagsHelper = [] as string[];

        for (const proposedTag of tags) {
          let found = false;
          for (const savedTag of v.filters.tags as string[]) {
            if (savedTag === proposedTag) {
              found = true;
              break;
            }
          }
          if (!found) {
            v.filters.tagsHelper.push(proposedTag);
          }
        }
      });
    },
    addSugestedTag(tagToAdd: string) {
      const input = this.$el.querySelector('#contentFiltersArea input') as HTMLInputElement;

      const tags = input.value.split(' ');

      // Clean the start of the tag
      tags.pop();
      // Add the complet tag
      tags.push(tagToAdd);

      this.loadContent(0, true, tags);

      input.value = tags.join(' ');

      this.filters.tagsHelper = [];

      input.focus();
    },
    addSugestedTagEnter(ev: KeyboardEvent, tag: string) {
      if (ev.keyCode === 13) {
        this.addSugestedTag(tag);

      }
    },
  },
  components: {
    filePreview,
    settingsPannel,
  },
});
